import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import FormControl from '@material-ui/core/FormControl';
import { TextField } from '@iris-platform/iris-react-ui';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import { withApollo } from 'react-apollo';
import {
  isEmpty,
} from 'ramda';
import {
  UPDATE_FGCM,
} from '../queries';
import { stylesToPropType, handleChange } from '../../../utils';

const styles = () => ({
  root: {
    width: '100%',
  },
  saveButton: {
    borderRadius: '0.125em',
    marginTop: '1em',
    width: '8em',
  },
});

class Fgcm extends Component {
  state = {
    gcmApiKey: '',
    error: null,
    fgcmKeyError: null,
    loading: true,
  };

  saveChanges = async () => {
    const {
      client,
      appType,
      childAppName,
      domain,
      enqueueSnackbar,
    } = this.props;
    const {
      gcmApiKey,
    } = this.state;

    const isGcmKeyInvalid = isEmpty(gcmApiKey);
    const hasError = isGcmKeyInvalid;

    const appDomainClientID = appType === 'child' ? `${domain}-${childAppName}` : domain;
    const fgcm = {
      app_domain_client_id: appDomainClientID,
      domain,
      gcm_api_key: gcmApiKey,
    };

    if (hasError) {
      const update = {
        fgcmKeyError: isGcmKeyInvalid ? new Error('gcm Key error') : null,
        error: new Error('Please fix all errors before saving'),
      };
      enqueueSnackbar('Failed to register key', { variant: 'error' });
      this.setState(update);
    } else {
      this.setState({ loading: true });

      try {
        await client.mutate({
          mutation: UPDATE_FGCM,
          variables: { fgcm },
        });
        enqueueSnackbar('Key successfully registered', { variant: 'success' });
        this.setState({ loading: false, error: null });
      } catch (error) {
        enqueueSnackbar('Failed to register key', { variant: 'error' });
        this.setState({ error: new Error('Unable to save changes, please try again later') });
      } finally {
        this.setState({
          loading: false,
          gcmApiKey: '',
        });
      }
    }
  }

  render() {
    const { classes } = this.props;
    const {
      gcmApiKey,
      fgcmKeyError,
      error,
      loading,
    } = this.state;

    return (
      <Fragment>
        <form>
          <FormControl className={classes.root} error={!!fgcmKeyError}>
            <TextField
              label="FCM/GCM Key"
              value={gcmApiKey || ''}
              onChange={(event) => {
                handleChange(this, ['gcmApiKey'])(event);
                this.setState({
                  fgcmKeyError: null,
                });
              }}
              type="text"
              placeholder="FCM/GCM"
              InputLabelProps={{ shrink: true }}
              margin="normal"
            />
            {fgcmKeyError && <FormHelperText>{fgcmKeyError.message}</FormHelperText>}
          </FormControl>
          <br />
          <FormControl className={classes.root} error={!!error}>
            <Button
              variant="contained"
              classes={{ root: classes.saveButton }}
              disabled={gcmApiKey === ''}
              onClick={this.saveChanges}
            >
              Register
            </Button>
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        </form>
      </Fragment>
    );
  }
}

Fgcm.propTypes = {
  appType: PropTypes.string.isRequired,
  childAppName: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  classes: stylesToPropType(styles()).isRequired,
  client: PropTypes.object.isRequired,
};

export default withSnackbar(withStyles(styles)(withApollo(Fgcm)));
